module.exports = __webpack_public_path__ + "static/media/option_a.441dfe69.png";